// src/stylesglobalsStyle.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
     
    overflow: hidden;
    overscroll-behavior-y: none;        /* Android/Chrome */
    background-color: #fff; 
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  #root {
    height: 100%;
    position: relative;
  }

  /* iOS PWA */
  @supports (-webkit-touch-callout: none) {
    body { -webkit-overflow-scrolling: auto; }  /* remove body inertion */
  }

  /* Pull-to-refresh - force z-index below header (header: 97) */
  /* Library uses classes: ptr--ptr, ptr--pul, etc. */
  /* Green background is applied via JavaScript based on current route */
  html body [class*="ptr--"],
  html body [class*="ptr--"] *,
  #root [class*="ptr--"],
  #root [class*="ptr--"] *,
  [class*="ptr--"],
  [class*="ptr--"] * {
    z-index: 50 !important;
  }
  
  /* Remove shadow from pull-to-refresh elements */
  [class*="ptr--ptr"],
  [class*="ptr--pul"] {
    box-shadow: none !important;
  }
  
  /* Pull-to-refresh icon styling - make it visible and styled */
  [class*="ptr--"] [class*="ptr--icon"] {
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 24px !important;
    min-width: 24px !important;
    color: #ffffff !important;
    font-size: 20px !important;
  }
  
  /* Hide empty text elements (first two instructions), show "Refreshing..." */
  [class*="ptr--"] [class*="text"],
  [class*="ptr--"] [class*="instruction"] {
    color: rgba(255, 255, 255, 0.9) !important;
    font-size: 14px !important;
  }
  
  /* Hide elements with zero-width space (empty instructions) */
  [class*="ptr--"] [class*="text"]:empty,
  [class*="ptr--"] [class*="instruction"]:empty {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    font-size: 0 !important;
    height: 0 !important;
    width: 0 !important;
  }
`;
